import React from 'react';
import { Typography } from '@mui/material';
import {
  isMetricScopeFilterActive,
  metricScopeFilterLabel,
} from './metricScopeFilters';

/**
 * Shown at the top of KPI drill-down sheets when scoped metrics differ from
 * the raw Recent Activity feed.
 */
const MetricScopeDrilldownNote = ({
  scope = 'demand',
  excludeInternal = false,
  excludePartnerAgents = false,
  partnerAgentEmailDomain = null,
}) => {
  if (!isMetricScopeFilterActive(scope, excludeInternal, excludePartnerAgents)) {
    return null;
  }

  return (
    <Typography
      sx={{
        fontSize: '0.75rem',
        color: 'rgba(0,0,0,0.5)',
        lineHeight: 1.5,
        mb: 1,
        px: 0.5,
      }}
    >
      Showing{' '}
      {metricScopeFilterLabel(
        scope,
        excludeInternal,
        excludePartnerAgents,
        partnerAgentEmailDomain
      )}
      . See all events in Recent Activity below.
    </Typography>
  );
};

export default MetricScopeDrilldownNote;
